import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { I18nLocaleFactory } from '../i18n/i18n.module';
import { I18nService } from '../i18n/i18n.service';

@Pipe({
    name: 'cmpsDate',
})
export class CmpsDatePipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, ...args: any[]): any {
        const locale = I18nLocaleFactory(this._i18nService);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return new DatePipe(locale).transform(value, <any>args);
    }
}
